<template>
    <div>
        <div class="lotto-wrapper">
            <div class="lotto-status">
                {{ $t('in play') }}
            </div>
            <LottoBetSlip
                :selected="selections"
                :selectionStatuses="selectionStatuses"
                :systems="[]"
                :eventDescription="eventDescription"
                :eventNo="eventNo"
            />
        </div>
        <div class="system-wrapper">
            <SystemRow
                v-if="system"
                v-bind="system"
            />
        </div>
    </div>
</template>

<script>
    import SystemRow from '@modules/shared/tickets/SystemRow';
    import LottoBetSlip from '@shared/lotto/betSlip/LottoBetSlip.vue';


    export default {
        props: {
            events: {
                type: Array,
                required: true,
            },
            system: {
                type: Object,
                required: null,
            },
        },
        computed: {
            selections() {
                return this.events.map((e) => parseInt(e.odd.name, 10));
            },
            selectionStatuses() {
                return this.events.map((e) => e.status);
            },
            eventNo() {
                return this.events[this.events.length - 1].eventNo;
            },
            eventDescription() {
                const event = this.events[0];
                const eventNameTokens = event.name.split('-');
                const [numbersDrawn, totalNumbers] = eventNameTokens[1]
                    .split('/')
                    .map((e) => parseInt(e.trim(), 10));

                return {
                    numbersDrawn,
                    totalNumbers,
                    eventName: eventNameTokens[0].trim(),
                    eventDate: event.date
                };
            },
        },
        components: {
            SystemRow,
            LottoBetSlip,
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/tickets/components/lotto/LottoEventWidget.vue